import React, { useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBranchList } from '../../actions/commonAction';
import { handleComplaint, openComplaint } from '../../reducers/uiSlice';
import { makeStyles } from '@material-ui/core/styles';
import UniDialog from '../Common/UniDialog';
import { useTranslation } from 'react-i18next';
import SearchDate from './SearchDate';
import DisplayAreas from './DisplayAreas';
import SearchDrivers from './SearchDrivers';
import DisplayRecords from './DisplayRecords';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        minHeight: '80vh'
    },
}));

function ComplaintModal() {
    const classes = useStyles();
    const {t} = useTranslation('complaint');
    const dispatch = useDispatch();

    const openModal = useSelector(openComplaint);

    const [branches, setBranches] = useState([]);
    const [branchId, setBranchId] = useState(-1);
    const [numList, setNumList] = useState([]);
    const [first, setFirst] = useState(false);
    const [change, setChange] = useState(false);
    const [complaintRate, setComplaintRate] = useState('');
    const [rows, setRows] = useState([]);
    const [rowsTemp, setRowsTemp] = useState([]);
    const [driverId, setDriverId] = useState('');

    function handleChooseArea(branchId) {
        setBranchId(branchId);
    }
    function handleNumList(list) {
        setNumList(list)
    }
    function handleChange(judge) {
        setChange(judge);
    }
    function handleComplaintRate(rate) {
        setComplaintRate(rate);
    }
    function handleRows(rowsCurr) {
        setRows(rowsCurr);
    }
    // First time open modal
    function handleFirst() {
        setFirst(false);
    }
    function handleRowsTemp(rowsTempCurr) {
        setRowsTemp(rowsTempCurr);
    }
    function handleDriverId(driverIdCurr) {
        setDriverId(driverIdCurr);
    }

    useEffect(() => {
        if(openModal) {
            const length = branches.length;
            let temp = [];
            (temp = []).length = length + 1; 
            temp.fill(0);
            setNumList(temp);
            setFirst(true);
            setChange(false);
            setDriverId('');
            dispatch(getBranchList()).then((branchesCurr)=>{
                setBranches(branchesCurr);
                const length = branchesCurr.length;
                let temp = [];
                (temp = []).length = length + 1; 
                temp.fill(0);
                setNumList(temp);
            })
        }
    }, [openModal])

    return (
        <UniDialog
            title={t('title_complaint')}
            maxWidth='lg'
            disableDefaultButtons
            open={openModal}
            onClose={handleClose}
        >
            <Grid 
                container 
                alignItems="center"
                justify="center"
                spacing={4}
            >
                <Grid item xs={12}>
                    <SearchDate
                        handleFirst={handleFirst}
                        handleChange={handleChange}
                    />
                </Grid>
                <Grid item xs={12}>
                    <DisplayAreas 
                        branches={branches} 
                        handleChooseArea={handleChooseArea} 
                        numList={numList}      
                        complaintRate={complaintRate}                  
                    />
                </Grid>
                <Grid item xs={12}>
                    <SearchDrivers
                        rows={rows}
                        handleRowsTemp={handleRowsTemp}
                        handleDriverId={handleDriverId}
                        driverId={driverId}
                    />
                </Grid>
                <Grid item xs={12}>
                    <DisplayRecords 
                        branches={branches} 
                        branchId={branchId}
                        handleNumList={handleNumList}
                        numList={numList}
                        first={first}
                        change={change}
                        handleFirst={handleFirst}
                        handleComplaintRate={handleComplaintRate}
                        handleRows={handleRows}
                        rowsTemp={rowsTemp}
                        driverId={driverId}
                    />
                </Grid>
            </Grid>
        </UniDialog>
    );

    /**
     * close the dialog
    */
    function handleClose() {
        dispatch(handleComplaint(false))
    }
}

export default ComplaintModal;